import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './axiosBaseQuery';
export const UPLOAD_DATA = 'uploadDataApi';

export const uploadDataApi = createApi({
    reducerPath: UPLOAD_DATA,
    baseQuery: apiBaseQuery,
    tagTypes: ['uploadData'],
    endpoints: (builder) => ({
        importExcel: builder.mutation({
            query: (body) => ({
                url: '/portfolio/import-excel',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['uploadData']
        }),
        getPortfolioImports: builder.query({
            query: ({ page, limit }) => ({
                url: `/portfolio/import-excel?page=${page}&limit=${limit}`
            }),
            providesTags: ['uploadData']
        }),

    })
});

export const {
    useGetPortfolioImportsQuery,
    useImportExcelMutation
} = uploadDataApi;